export default __webpack_public_path__ + "static/jsconf-a783d17aaf060da79b937d2896646df9.png";